(() => {
  angular
  .module('gm.common.directives')
  .directive('gmSubmit', gmSubmit);

  function gmSubmit(
    $parse
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      compile(_element, attrs) {
        // We expose the powerful $event object on the scope that provides access to the Window,
        // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
        // checks at the cost of speed since event handler expressions are not executed as
        // frequently as regular change detection.
        const fn = $parse(attrs.gmSubmit, /* interceptorFn */ null, /* expensiveChecks */ true);

        return function _gmSubmit(scope, element) {
          element.on('submit', ($event) => {
            const btnEl = element.find('button:submit');

            btnEl.addClass('loading-button');
            btnEl.prop('disabled', true);

            const callback = () => {
              const result = fn(scope, { $event });
              if (result && angular.isFunction(result.finally)) {
                result.finally(() => {
                  btnEl.removeClass('loading-button');
                  btnEl.prop('disabled', false);
                });
              } else {
                btnEl.removeClass('loading-button');
                btnEl.prop('disabled', false);
              }
            };
            scope.$apply(callback);
          });
        };
      }
    };
    return directive;
  }
})();
